import axios from 'axios'
import endpoints from '../../endpoints'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchBusList() {
  try {
    const response = await axios.get(API_URL + endpoints.bus.list)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function createBus(body: any) {
  try {
    const response = await axios.put(API_URL + endpoints.bus.create, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function updateBus(body: any) {
  try {
    const response = await axios.post(API_URL + endpoints.bus.update, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function deleteBus(busId: number) {
  try {
    const response = await axios.delete(API_URL + endpoints.bus.delete + busId)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function addGPStoBus(payload: any) {
  try {
    const response = await axios.put(API_URL + endpoints.bus.addGPS, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function getGPS(busId: any) {
  try {
    const response = await axios.get(API_URL + endpoints.bus.getGPS + busId)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function addPIRtoBus(payload: any) {
  try {
    const response = await axios.put(API_URL + endpoints.bus.addPIR, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function getPIR(busId: any) {
  try {
    const response = await axios.get(API_URL + endpoints.bus.getPIR + busId)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function addNFCtoBus(payload: any) {
  try {
    const response = await axios.put(API_URL + endpoints.bus.addNFC, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function getNFC(busId: any) {
  try {
    const response = await axios.put(API_URL + endpoints.bus.getNFC, {
      bus_id: busId,
    })
    return response.data
  } catch (error) {
    throw error
  }
}
